"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LinearGraph;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%'
    },
    segment: {
      display: 'inline-flex'
    },
    segmentsContainer: {
      backgroundColor: theme.palette.background.default,
      display: 'flex',
      overflow: 'hidden',
      width: '100%'
    },
    segmentSizeRight: {
      marginTop: -6,
      paddingLeft: 4,
      position: 'absolute'
    },
    segmentSizesContainer: {
      display: 'flex',
      width: '100%'
    },
    segmentTitle: {
      overflow: 'hidden',
      textAlign: 'center',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    titlesContainer: {
      display: 'flex',
      width: '100%'
    }
  };
});
function LinearGraph(_ref) {
  var backgroundColor = _ref.backgroundColor,
    className = _ref.className,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 8 : _ref$height,
    id = _ref.id,
    segments = _ref.segments,
    showSegmentSizeRight = _ref.showSegmentSizeRight,
    showSegmentSizesBottom = _ref.showSegmentSizesBottom,
    showTitlesTop = _ref.showTitlesTop,
    total = _ref.total;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container,
    id: id
  }, showTitlesTop && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.segmentSizesContainer,
    id: "".concat(id, "SegmentTitles")
  }, segments.map(function (segment, i) {
    if (segment.size) {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, {
        key: segment.title,
        className: classes.segmentTitle,
        id: "".concat(id, "SegmentTitles").concat(i),
        style: {
          color: segment.textColor,
          width: "".concat(segment.size * 100 / total, "%")
        },
        variant: "caption"
      }, segment.title);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: segment.title,
      id: "".concat(id, "SegmentTitles").concat(i)
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.segmentsContainer, className),
    id: "".concat(id, "Segments"),
    style: {
      backgroundColor,
      borderRadius: 2,
      height
    }
  }, segments.map(function (segment, i) {
    var borderRightRadius = i === segments.length - 1 ? 2 : 0;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: segment.title,
      className: classes.segment,
      id: "".concat(id, "SegmentsSegment").concat(i),
      style: {
        backgroundColor: segment.color,
        borderBottomRightRadius: borderRightRadius,
        borderTopRightRadius: borderRightRadius,
        width: "".concat(segment.size * 100 / total, "%")
      }
    });
  })), showSegmentSizesBottom && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.segmentSizesContainer,
    id: "".concat(id, "SegmentSizes")
  }, segments.map(function (segment, i) {
    if (segment.size) {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, {
        key: segment.title,
        className: classes.segmentTitle,
        id: "".concat(id, "SegmentSizes").concat(i),
        style: {
          color: segment.textColor,
          width: "".concat(segment.size * 100 / total, "%")
        },
        variant: "caption"
      }, segment.size);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      key: segment.title,
      id: "".concat(id, "SegmentSizes").concat(i)
    });
  })), segments[segments.length - 1] && showSegmentSizeRight && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.segmentSizeRight,
    id: "".concat(id, "SegmentSize"),
    style: {
      marginLeft: "".concat(segments[segments.length - 1].size * 100 / total, "%")
    },
    variant: "body2"
  }, segments[segments.length - 1].size));
}